import { render } from "./ProjetsView.vue?vue&type=template&id=859b17a0&scoped=true"
import script from "./ProjetsView.vue?vue&type=script&lang=js"
export * from "./ProjetsView.vue?vue&type=script&lang=js"

import "./ProjetsView.vue?vue&type=style&index=0&id=859b17a0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-859b17a0"]])

export default __exports__